import { IconButton, Tooltip } from "@material-ui/core";
import { LiveHelp } from "@material-ui/icons";
import React from "react";
import { useHistory } from "react-router-dom";

export const Component: React.FC = () => {
  const history = useHistory();

  return (
    <Tooltip title="Support">
      <IconButton
        aria-label={`support`}
        color="inherit"
        onClick={() => {
          history.push(`/links`);
        }}
        data-test="support-icon"
      >
        <LiveHelp />
      </IconButton>
    </Tooltip>
  );
};
